(() => {
  const Z = window.Zynera || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Money ---------- */

  function formatMoney(cents, format = Z.moneyFormat || '${{amount_no_decimals_with_comma_separator}}') {
    const value = Number(cents) / 100;
    const group = (num, decimals, thousands, decimal) => {
      const [int, frac] = num.toFixed(decimals).split('.');
      const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + decimal + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount':
          return group(value, 2, ',', '.');
        case 'amount_no_decimals':
          return group(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return group(value, 2, "'", '.');
        default:
          return group(value, 0, '.', ',');
      }
    });
  }

  const escapeHtml = (str) =>
    String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const announce = (msg) => {
    const live = $('#CartStatus');
    if (live) {
      live.textContent = '';
      requestAnimationFrame(() => (live.textContent = msg));
    }
  };

  /* ---------- Packs ---------- */

  function syncPack(form) {
    const checked = $('input[data-pack-qty]:checked', form);
    if (!checked) return;
    $('[data-variant-input]', form).value = checked.dataset.packVariant;
    $('[data-quantity-input]', form).value = checked.dataset.packQty;
    const price = formatMoney(checked.dataset.packPrice);
    const total = $('[data-total-price]', form);
    if (total) total.textContent = price;
    const compare = $('[data-total-compare]', form);
    if (compare) {
      const value = checked.dataset.packCompare;
      compare.hidden = !value;
      compare.textContent = value ? formatMoney(value) : '';
    }
  }

  $$('[data-product-form]').forEach((form) => {
    syncPack(form);
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[data-pack-qty]')) syncPack(form);
    });
  });

  /* ---------- Cart ---------- */

  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  async function getCart() {
    const res = await fetch(Z.routes.cart, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function renderCount(cart) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.toggleAttribute('data-empty', cart.item_count === 0);
      if (!reduceMotion) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    const body = $('[data-cart-lines]', drawer);
    if (cart.item_count === 0) {
      body.innerHTML = `<p class="drawer__empty">${escapeHtml(Z.strings.empty)}</p>`;
    } else {
      body.innerHTML = cart.items
        .map((item) => {
          const img = item.image
            ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=160" alt="${escapeHtml(item.product_title)}" width="80" height="80">`
            : '';
          const variant =
            item.variant_title && !item.product_has_only_default_variant
              ? `<p class="line__variant">${escapeHtml(item.variant_title)}</p>`
              : '';
          return `
            <div class="line" data-line-key="${item.key}">
              <div class="line__media">${img}</div>
              <div class="line__info">
                <p class="line__title">${escapeHtml(item.product_title)}</p>
                ${variant}
                <div class="qty" data-qty>
                  <button type="button" class="qty__btn" data-qty-change="-1" aria-label="-1">${iconMinus}</button>
                  <span class="qty__value tnum">${item.quantity}</span>
                  <button type="button" class="qty__btn" data-qty-change="1" aria-label="+1">${iconPlus}</button>
                </div>
              </div>
              <p class="line__price tnum">${formatMoney(item.final_line_price)}</p>
            </div>`;
        })
        .join('');
    }
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    const checkout = $('[data-checkout]', drawer);
    if (cart.item_count === 0) checkout.setAttribute('aria-disabled', 'true');
    else checkout.removeAttribute('aria-disabled');
  }

  const svg = (d) =>
    `<svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="${d}"/></svg>`;
  const iconMinus = svg('M5 12h14');
  const iconPlus = svg('M12 5v14M5 12h14');

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      $('.drawer__panel', drawer).focus();
    });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    const panel = $('.drawer__panel', drawer);
    const done = () => {
      drawer.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    if (reduceMotion) done();
    else panel.addEventListener('transitionend', done);
    if (lastFocus) lastFocus.focus();
  }

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-drawer-close]')) return closeDrawer();
      const checkout = e.target.closest('[data-checkout]');
      if (checkout && checkout.getAttribute('aria-disabled') === 'true') return e.preventDefault();
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const line = btn.closest('[data-line-key]');
      const current = Number($('.qty__value', line).textContent);
      const quantity = Math.max(0, current + Number(btn.dataset.qtyChange));
      line.classList.add('is-updating');
      try {
        const res = await fetch(Z.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.dataset.lineKey, quantity })
        });
        const cart = await res.json();
        renderDrawer(cart);
        renderCount(cart);
      } catch (err) {
        line.classList.remove('is-updating');
      }
    });

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') return closeDrawer();
      if (e.key !== 'Tab') return;
      const focusable = $$('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer).filter(
        (el) => el.offsetParent !== null
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    $$('[data-cart-toggle]').forEach((el) =>
      el.addEventListener('click', async (e) => {
        if (Z.cartDrawer === false) return;
        e.preventDefault();
        openDrawer();
        try {
          renderDrawer(await getCart());
        } catch (err) {}
      })
    );
  }

  /* The signature: a livery band sweeps the screen when the bottle goes in the cart. */
  function sweep() {
    const el = $('.livery-sweep');
    if (!el || reduceMotion) return Promise.resolve();
    el.classList.remove('is-running');
    void el.offsetWidth;
    el.classList.add('is-running');
    return new Promise((resolve) => {
      setTimeout(resolve, 560);
      setTimeout(() => el.classList.remove('is-running'), 1050);
    });
  }

  async function addToCart(form, { thenCheckout = false } = {}) {
    const button = $('[data-add-button]', form);
    const label = $('[data-add-label]', form);
    const error = $('[data-form-error]', form);
    const original = label ? label.textContent : '';
    error.hidden = true;
    button.disabled = true;
    button.classList.add('is-loading');
    if (label) label.textContent = Z.strings.adding;

    try {
      const res = await fetch(Z.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || Z.strings.error);

      if (thenCheckout) {
        window.location.href = Z.routes.checkout;
        return;
      }

      const cart = await getCart();
      renderCount(cart);
      renderDrawer(cart);
      announce(Z.strings.added);
      await sweep();
      if (Z.cartDrawer !== false && drawer) openDrawer();
    } catch (err) {
      error.textContent = err.message || Z.strings.error;
      error.hidden = false;
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      if (label) label.textContent = original;
    }
  }

  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
    const buyNow = $('[data-buy-now]', form);
    if (buyNow) buyNow.addEventListener('click', () => addToCart(form, { thenCheckout: true }));
  });

  /* ---------- Sticky buy bar ---------- */

  const sticky = $('[data-sticky-buy]');
  const heroActions = $('.hero .buy-box__actions');
  if (sticky && heroActions && 'IntersectionObserver' in window) {
    const heroForm = heroActions.closest('form');
    const setOffset = (on) =>
      document.documentElement.style.setProperty('--sticky-h', on ? `${sticky.offsetHeight}px` : '0px');
    // Show the bar only between the hero's buy box and the closing band's: never two add buttons at once.
    const closingBuy = $('.closing .buy-box');
    let heroPast = false;
    let closingInView = false;
    const update = () => {
      const show = heroPast && !closingInView;
      sticky.hidden = false;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      setOffset(show);
    };
    new IntersectionObserver(
      ([entry]) => {
        heroPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      },
      { threshold: 0 }
    ).observe(heroActions);
    if (closingBuy) {
      new IntersectionObserver(
        ([entry]) => {
          closingInView = entry.isIntersecting;
          update();
        },
        { threshold: 0 }
      ).observe(closingBuy);
    }

    $('[data-sticky-cta]', sticky).addEventListener('click', (e) => {
      if (!heroForm) return;
      e.preventDefault();
      heroForm.requestSubmit();
    });

    if (heroForm) {
      const priceEl = $('[data-sticky-price]', sticky);
      heroForm.addEventListener('change', () => {
        const total = $('[data-total-price]', heroForm);
        if (priceEl && total) priceEl.textContent = total.textContent;
      });
    }
  }

  /* ---------- 30-day gauge: fills once, day by day ---------- */

  const gauge = $('[data-gauge]');
  if (gauge && !reduceMotion && 'IntersectionObserver' in window) {
    const counter = $('[data-gauge-day]', gauge);
    const total = Number(counter.textContent);
    gauge.classList.add('is-armed');
    counter.textContent = '0';
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        gauge.classList.remove('is-armed');
        const start = performance.now();
        const duration = total * 28 + 180;
        const step = (now) => {
          const t = Math.min(1, (now - start) / duration);
          counter.textContent = String(Math.round(t * total));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      },
      { threshold: 0.5 }
    );
    io.observe(gauge);
  }

  /* ---------- Hero review rotator: one quote at a time, cycling ---------- */

  $$('[data-rotator]').forEach((root) => {
    const items = $$('[data-rotator-item]', root);
    const dots = $$('[data-rotator-dot]', root);
    if (items.length < 2) return;
    const interval = 5000;
    let index = 0;
    let timer = null;
    let paused = false;

    const show = (next) => {
      index = (next + items.length) % items.length;
      items.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, i) => (i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
    };
    const stop = () => {
      clearTimeout(timer);
      timer = null;
      root.classList.remove('is-playing');
    };
    const play = () => {
      stop();
      if (paused || reduceMotion || document.hidden) return;
      // Restart the dot's progress animation in step with the timer.
      void root.offsetWidth;
      root.classList.add('is-playing');
      timer = setTimeout(() => {
        show(index + 1);
        play();
      }, interval);
    };

    dots.forEach((dot) =>
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.rotatorDot));
        play();
      })
    );
    const pause = () => {
      paused = true;
      root.classList.add('is-paused');
      stop();
    };
    const resume = () => {
      paused = false;
      root.classList.remove('is-paused');
      play();
    };
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) resume();
    });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));

    show(0);
    play();
  });

  /* ---------- Email pop-up: cards, one question, email, code ---------- */

  const popup = $('[data-popup]');
  if (popup) {
    const KEY = popup.dataset.key || 'rw-popup';
    const WEEK = 7 * 24 * 60 * 60 * 1000;
    const store = {
      get() {
        try {
          return localStorage.getItem(KEY);
        } catch (e) {
          return null;
        }
      },
      set(value) {
        try {
          localStorage.setItem(KEY, value);
        } catch (e) {}
      }
    };
    const panel = $('.popup__panel', popup);
    const steps = $$('[data-step]', popup);
    const cards = $('[data-cards]', popup);
    const progress = $('[data-cards-progress]', popup);
    const form = $('[data-popup-form]', popup);
    const email = $('[data-popup-email]', popup);
    const tags = $('[data-popup-tags]', popup);
    const error = $('[data-popup-error]', popup);
    const submit = $('[data-popup-submit]', popup);
    const submitLabel = $('[data-popup-submit-label]', popup);
    const baseTags = tags ? tags.value : 'newsletter';
    let lastFocus = null;
    let answerTag = '';

    const showStep = (name) => {
      steps.forEach((step) => {
        const active = step.dataset.step === name;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      const target = name === 'email' ? email : $('[data-step="' + name + '"] h2', popup);
      if (target) {
        if (target.tagName === 'H2') target.setAttribute('tabindex', '-1');
        requestAnimationFrame(() => target.focus({ preventScroll: true }));
      }
    };

    const open = (step = 'cards') => {
      if (!popup.hidden) return;
      lastFocus = document.activeElement;
      popup.hidden = false;
      popup.classList.add('is-open');
      document.documentElement.classList.add('popup-lock');
      showStep(step);
    };

    const close = () => {
      if (popup.hidden) return;
      popup.hidden = true;
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('popup-lock');
      if (store.get() !== 'subscribed') store.set('closed:' + Date.now());
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    // Step 1: flip three cards; every card hides the same gift.
    let flipped = 0;
    if (cards) {
      cards.addEventListener('click', (e) => {
        const card = e.target.closest('[data-card]');
        if (!card || card.classList.contains('is-flipped') || flipped >= 3) return;
        card.classList.add('is-flipped');
        card.disabled = true;
        flipped += 1;
        if (flipped < 3) {
          progress.textContent = flipped === 1 ? 'Te quedan 2 cartas' : 'Te queda 1 carta';
          return;
        }
        progress.textContent = '¡3 iguales! Desbloqueaste tu regalo';
        cards.classList.add('is-won');
        $$('[data-card]', cards).forEach((c) => (c.disabled = true));
        setTimeout(() => showStep('question'), reduceMotion ? 300 : 1300);
      });
    }

    // Step 2: one question; the answer becomes a customer tag.
    $$('[data-answer]', popup).forEach((button) =>
      button.addEventListener('click', () => {
        $$('[data-answer]', popup).forEach((b) => b.classList.toggle('is-chosen', b === button));
        answerTag = button.dataset.answer || '';
        setTimeout(() => showStep('email'), reduceMotion ? 0 : 220);
      })
    );

    // Step 3: the email goes to Shopify as a subscribed customer.
    const showError = (message) => {
      error.textContent = message;
      error.hidden = false;
      email.setAttribute('aria-invalid', 'true');
    };
    if (form) {
      email.addEventListener('input', () => {
        error.hidden = true;
        email.removeAttribute('aria-invalid');
      });
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const value = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
          showError('Escribe un correo válido, por ejemplo nombre@correo.cl.');
          email.focus();
          return;
        }
        tags.value = answerTag ? baseTags + ',' + answerTag : baseTags;
        submit.disabled = true;
        submit.classList.add('is-loading');
        submitLabel.textContent = 'Enviando…';
        // A real form post: Shopify saves the subscriber (and shows its captcha when it wants one),
        // then reloads this page with customer_posted=true, where the pop-up opens on the code.
        HTMLFormElement.prototype.submit.call(form);
      });
    }

    // Step 4: copy or apply the code.
    const copy = $('[data-popup-copy]', popup);
    if (copy) {
      copy.addEventListener('click', async () => {
        const code = $('[data-popup-code]', popup).textContent.trim();
        try {
          await navigator.clipboard.writeText(code);
          copy.textContent = '¡Copiado!';
        } catch (e) {
          const range = document.createRange();
          range.selectNodeContents($('[data-popup-code]', popup));
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          copy.textContent = 'Selecciónalo';
        }
        setTimeout(() => (copy.textContent = 'Copiar'), 2200);
      });
    }

    $$('[data-popup-close]', popup).forEach((b) => b.addEventListener('click', close));
    popup.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') return close();
      if (e.key !== 'Tab') return;
      const focusable = $$('button:not([disabled]), a[href], input:not([type="hidden"])', panel).filter(
        (el) => el.offsetParent !== null
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // When to show it.
    const state = store.get() || '';
    if ($('[data-popup-posted]', popup)) {
      store.set('subscribed');
      open('done');
    } else if ($('[data-popup-failed]', popup)) {
      open('email');
    } else if (popup.hasAttribute('data-design-mode')) {
      document.addEventListener('shopify:section:select', (e) => {
        if (popup.closest('[id^="shopify-section"]')?.contains(e.target) || e.target.contains(popup)) open();
      });
      document.addEventListener('shopify:section:deselect', close);
    } else if (state !== 'subscribed') {
      const closedAt = Number(state.split(':')[1] || 0);
      if (!closedAt || Date.now() - closedAt > WEEK) {
        setTimeout(() => open(), Number(popup.dataset.delay || 6) * 1000);
      }
    }
  }
})();
